import styled, { css } from 'styled-components';

import { IDeleteRowProps } from '.';

export const Container = styled.button<IDeleteRowProps>`
  ${({ theme }) => css`
    background-color: ${theme.colors.deleteRow};
    color: #fff;
    padding: 8px;
    border-radius: 50%;
    box-shadow: 1px 1px 1px ${theme.colors.lightGrey};

    &:hover {
      transform: scale(1.2, 1.2);
    }
  `}
`;
